var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganisationPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n        stroke: #89397d;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x2018_\\xEB\\xEE\\xE9_x5F_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 2.5,
    y: 37.26,
    width: 9.73,
    height: 10.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 20.14,
    y: 37.26,
    width: 9.73,
    height: 10.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 37.77,
    y: 37.26,
    width: 9.73,
    height: 10.24
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.64,33.61v-3.95c0-1.26-.97-2.28-2.16-2.28H9.53c-1.2,0-2.16,1.02-2.16,2.28v3.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25,
    y1: 33.61,
    x2: 25,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 16.55,
    y: 2.92,
    width: 16.9,
    height: 16.06,
    transform: "translate(14.05 35.95) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationPurple);
export default __webpack_public_path__ + "static/media/organisation-purple.6bff0b279dbae2eb97e7c06b311f2e1a.svg";
export { ForwardRef as ReactComponent };